'use client';

import { useEffect, useState } from 'react';

export default function PortfolioHero() {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate');
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -5% 0px' }
    );

    const elements = document.querySelectorAll('.animate-on-scroll');
    elements?.forEach((el) => observer?.observe(el));

    return () => observer?.disconnect();
  }, []);

  return (
    <section className="pt-32 pb-20 lg:pt-40 lg:pb-32 relative overflow-hidden">
      <div className="container mx-auto px-6 max-w-7xl">
        <div className="text-center animate-on-scroll animate-in">
          <span className="text-xs uppercase tracking-[0.4em] text-blue-400 mb-6 block">
            Our Work
          </span>
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-8 leading-tight">
            Projects That <br />
            <span className="text-gradient-blue">Drive Results</span>
          </h1>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto leading-relaxed">
            Discover how we've helped businesses across the UK achieve their technology goals with innovative, scalable solutions.
          </p>
        </div>
      </div>
    </section>
  );
}